// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "user_id": '',
    "user_name": '',
    "user_name_domain":'',
    "first_name": '',
    "last_name": '',
    'status':[],
    "permission":[],
    "email_address":'',
    "email_address_domain": '',
    "mobile_number":'',
    "mobile_number_code":'',
    "main_number_code":'',
    "main_number":'',
    "patient_full_name":'',
    "created_day": '',
    "created_month": '',
    "created_year": '',
    "user_id_inverse": '',
    "user_name_inverse": '',
    "first_name_inverse": '',
    "last_name_inverse": '',
    "email_address_inverse":'',
    "mobile_number_inverse":'',
    "main_number_inverse":'',
    "created_date_inverse": '',
    "patient_full_name_inverse":'',
    'permission_inverse':'',
    "status_inverse": '',
    "match": false,
    "org_user_searchApplied": false,

};

const orgUserSearchSlice = createSlice({
    name: 'providerSearch',
    initialState,
    reducers: {
        setOrgUserSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetOrgUserSearch(state) {
            return { ...initialState, org_user_searchApplied: false }; // Reset state and flag
        },
        setOrgUserSearchApplied(state) {
            state.org_user_searchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setOrgUserSearch, resetOrgUserSearch,setOrgUserSearchApplied } = orgUserSearchSlice.actions;

export default orgUserSearchSlice.reducer;